import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Select from 'react-select';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function UpdateCalculationsModal({
  createInput,
  updateCalculations,
  formData,
  setFormData,
  getCalculationsList,
  id,
  getCalculationsType,
  calculationsType,
  calculationsId,
  updateList,
  calculationsInfo,
}) {
  const setModal = useContext(ModalContext);

  useEffect(() => {
    getCalculationsType();
  }, []);

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      multiplier: _.get(formData, 'multiplier'),
      // label: _.get(formData, 'label'),
      tax_revenue_calculation_type_id: _.get(
        formData,
        'tax_revenue_calculation_type_id'
      ),
      for_new: _.get(formData, 'for_new') ? _.get(formData, 'for_new') : false,
      for_renewal: _.get(formData, 'for_renewal')
        ? _.get(formData, 'for_renewal')
        : false,
    };

    updateCalculations(id, calculationsId, args, () => {
      setModal({ isOpen: false });
      getCalculationsList(id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const selectCalculationsType = calculationsType.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
    is_multiple: _.get(x, 'attributes.is_multiple'),
  }));

  const handleDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
      is_multiple: e ? e.is_multiple : '',
    });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked ? 1 : 0,
    });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
        tax_revenue_calculation_type_id: _.get(
          calculationsInfo,
          'included.type.id'
        ),
      };
      setFormData(_.pick(args, _.keys(c.CALCULATIONS_FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, {});

  const findValue =
    selectCalculationsType.find(
      item => +_.get(formData, 'tax_revenue_calculation_type_id') === +item.id
    ) || '';

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label">
              For New: &nbsp;
            </label>
            <input
              name="for_new"
              type="checkbox"
              checked={_.get(formData, 'for_new')}
              onChange={onChange}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label">
              For Renewal: &nbsp;
            </label>
            <input
              name="for_renewal"
              type="checkbox"
              checked={_.get(formData, 'for_renewal')}
              onChange={onChange}
            />
          </div>

          <div className="col-12 form-group">
            <Select
              isDisabled="true"
              options={selectCalculationsType}
              placeholder="Select Calculation Type"
              onChange={handleDropDownChange('tax_revenue_calculation_type_id')}
              value={findValue}
            />
          </div>

          {_.get(findValue, 'is_multiple') ? (
            <div className="col-12 form-group">
              <div className="">
                {createInput(
                  { key: 'multiplier', label: 'Multiplier:' },
                  { placeholder: 'Ex. code_multiplier', required: true }
                )}
              </div>
              {/* <div className="">
                {createInput(
                  { key: 'label', label: 'Label:' },
                  { placeholder: 'Label', required: true }
                )}
              </div> */}
            </div>
          ) : (
            ' '
          )}
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3">
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateCalculationsModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  getCalculationsList: PropTypes.instanceOf(Function).isRequired,
  updateCalculations: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  getCalculationsType: PropTypes.instanceOf(Function).isRequired,
  calculationsType: PropTypes.instanceOf(Array).isRequired,
  calculationsId: PropTypes.string.isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  calculationsInfo: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  calculationsType: _.get(api, `${c.GET_CALCULATIONS_TYPE_LICENSE}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateCalculationsModal);
